import React from 'react';
import PropTypes from 'prop-types';
import { DE_DE, FR_FR } from 'utils/constants/LanguageRegionCode';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import { LanguageSupportUtil } from 'utils/language_support_util';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import * as styles from './styles/styles.module.scss';
import OnePercentModule from './OnePercentModule';
import oneTreeSrc from './one-tree.svg';
import onePercentSrc from './one-percent.svg';
import noTraceSrc from './no-trace.svg';

const {
  HOME_PAGE: {
    ONE_PERCENT_BLOCK: {
      ONE_PERCENT_FOR_THE_PLANET,
      A_PORTION_OF_EVERY,
      TEN_THOUSAND_AND_COUNTING,
      NO_TRACE_ON_THE_TRAIL,
      FROM_OUR_BIRTHDAY,
      AS_A_NO_TRACE_PARTNER,
      GET_PRO_AND_GIVE_BACK,
      GIVE_PRO_AND_GIVE_BACK
    }
  }
} = StringConstantsMixin.strings;

const OnePercentBlock = ({ proUser }) => {
  const languageRegionCode = useLanguageRegionCode();

  const [ctaUrl, ctaLabel] = proUser
    ? ['/gift?ref=homepage_gift_onepercentblock', GIVE_PRO_AND_GIVE_BACK]
    : ['/pro?ref=homepage_pro_onepercentblock', GET_PRO_AND_GIVE_BACK];

  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <div className={styles.modulesContainer}>
          <OnePercentModule iconSrc={onePercentSrc} title={ONE_PERCENT_FOR_THE_PLANET} text={A_PORTION_OF_EVERY} />
          <OnePercentModule iconSrc={oneTreeSrc} title={TEN_THOUSAND_AND_COUNTING} text={FROM_OUR_BIRTHDAY} />
          <OnePercentModule iconSrc={noTraceSrc} title={NO_TRACE_ON_THE_TRAIL} text={AS_A_NO_TRACE_PARTNER} />
        </div>
        <a
          href={LanguageSupportUtil.wrapUrlSafe(ctaUrl, languageRegionCode)}
          data-testid="get-pro-and-give-back"
          className={`${styles.ctaLink} ${[DE_DE, FR_FR].includes(languageRegionCode) ? styles.smallCtaText : ''}`}
        >
          {ctaLabel}
        </a>
      </div>
    </div>
  );
};

OnePercentBlock.propTypes = {
  proUser: PropTypes.bool
};

OnePercentBlock.defaultProps = {
  proUser: null
};

export default OnePercentBlock;
